export default "__VITE_ASSET__DuNB4fbq__"